module.exports = __webpack_public_path__ + "img/signature.aa79c5c.jpg";